import React, { useState } from 'react';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Avatar, Button, CircularProgress, Container, CssBaseline, Grid, Typography } from "@mui/material";
import clsx from 'clsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars/index.js";
import { browserHistory } from '../../helpers/history';
import Api from "../../services/api";
import { Overlay } from "../../styles/global.js";
import { Styles } from '../../styles/material-styles';
import { withStyles } from '@mui/styles';
import { NotificationVariant } from 'src/utils/enums/notification-variants.enum';
import { LLMType } from 'src/utils/enums/llm-type.enum';
import FormEditOpenAi from './components/openai/index'
import { PapiroConsole } from 'src/utils/papiroConsole';

const LLMEdit = (props) => {
  const { classes, intl, match } = props;

  const history = browserHistory;
  
  const { headerMenu, actionsHeaderMenu, userSession, llms } = useSelector(state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
    llms: state.llms
  }));
  
  const [loading, setLoading] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationVariant, setNotificationVariant] = useState('error');
  const [notificationMessage, setNotificationMessage] = useState('');
  
  if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
    Api.logoff();
  }

  if (Api == null) {
    const language = props.match.params.lang;
    document.location.href=`/${language}/unavailable`;
  }
  
  const closeNotification = () => {
    setOpenNotification(false);
  };

  const showNotification = (message, variant = NotificationVariant.SUCCESS) => {
    setLoading(false);
    setOpenNotification(true);
    setNotificationVariant(variant);
    setNotificationMessage(message);
  };
  
  return (
    <div className={classes.root}>
      <HeaderMenu />

      <main
        className={clsx(classes.content, {
          [classes.contentShift]: headerMenu.open,
        }, classes.actionsContent, {
          [classes.actionscontentShift]: actionsHeaderMenu.open,
        })}
      >
        <div className={classes.drawerHeader} />
        
        <Container component='main' maxWidth='md'>
          <CssBaseline />
          <div className={classes.paper} style={{ marginTop: 0 }}>
            <Grid container spacing={6}>
              <Grid item xs={12} sm={4}>
                <Button variant='outlined' color='primary' onClick={history.goBack}>
                  <FormattedMessage id="back" />
                </Button>
              </Grid>
              <Grid item xs={12} sm={8} />
            </Grid>

            <Avatar mt={7} style={{ backgroundColor: '#303f9f', color: 'white' }}>
              <SmartToyIcon />
            </Avatar>

            <Typography component='h1' variant='h5' mt={2}>
              {intl.formatMessage({ id: "llm.edit" })}
            </Typography>
             
            {llms?.llm?.llmtypeid === LLMType.CHATGPT && (
              <FormEditOpenAi
                onShowNotification={showNotification}
                onSetLoading={setLoading}
                loading={loading}
                classes={classes}
                hirerid={userSession?.user?.hirerid}
                match={match}
              />
            )}
          </div>
          
          {loading && (
            <Overlay>
              <CircularProgress color='secondary' />
            </Overlay>
          )}
          
          {openNotification && (
            <CustomizedSnackbars
              variant={notificationVariant}
              message={notificationMessage}
              isOpen={openNotification}
              toClose={closeNotification}
            />
          )}          
        </Container>
      </main>
    </div>
  );
};

export default injectIntl(withStyles(Styles)(LLMEdit));